import { Link, NavLink, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("ottToken");
    navigate("/");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg px-0 py-1 mb-1 sticky-top">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img
              src="/assets/images/fndrma-logo.png"
              width="200"
              alt=""
              className="d-lg-block d-none"
            />
            <img
              src="/assets/images/fndrma-logo.png"
              width="150"
              alt=""
              className="d-lg-none d-block"
            />
          </Link>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div class="d-none d-md-block">
              <button
                onClick={handleLogout}
                class="btn btn-primary px-5 rounded-3 text-white"
              >
                Logout
              </button>
            </div>
          </div>
          <div>
            <button
              className="navbar-toggler collapsed ms-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar mt-0" />
              <span className="icon-bar middle-bar" />
              <span className="icon-bar bottom-bar" />
            </button>
          </div>
          <div className="collapse navbar-collapse ps-lg-5" id="navbar-default">
            <ul className="navbar-nav mt-3 mt-lg-0">
              <li className="nav-item">
                <NavLink to="/ott/dashboard" className="nav-link">
                  Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/ott/projects" className="nav-link">
                  Projects
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/ott/unreleased" className="nav-link">
                  Unreleased
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/ott/released" className="nav-link">
                  Released
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
